import SetMeterReadsBanner from '@/src/components/Banners/SetMeterReadsBanner';
import useWindowDimensions from '@/src/utils/hooks/useWindowDimensions';
import { ProfileView } from '@ovotech/energy-cx';
import { Stack } from '@ovotech/nebula';
import React from 'react';

export const ProfileStack = () => {
  const { width } = useWindowDimensions({ debounceDelay: 0 });
  const isMobile = width < 576;

  return (
    <Stack spaceBetween={isMobile ? 4 : 8}>
      <ProfileView />
      <SetMeterReadsBanner />
    </Stack>
  );
};
